<template>
  <div class="col backgroundForm">
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#nav-new-user" role="tab" aria-controls="nav-new-user" aria-selected="true"><font-awesome-icon icon="th-list" /> Operador de Personal</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-list-user" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="user-plus" /> Listado de Usuarios Temporales Habilitados de la Unidad</a>
        </div>
    </nav>
    
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="nav-new-user" role="tabpanel" aria-labelledby="nav-new-user-tab">
            <br><br>
    
            <h5 align="center">Formulario de transferencia de privilegios y acceso al sistema</h5>
            <vue-bootstrap-typeahead                            
                    v-model="persons"
                    :data="persons_list"
                    size="sm"
                    :serializer="item => (item.grade +' '+item.complete+' CI. '+item.identification)"
                    @hit="mSelectPerson"
                    :placeholder="searchPerson"                                        
                />
            <br><br>
            <div v-if="person_select.id > 0">
                <h6><b>Personal Seleccionada a Habilitar a la Unidad para registro de personal</b></h6>
                <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text">{{person_select.grade}} {{person_select.complete}} <b> &nbsp; C.I. &nbsp;</b>{{ person_select.identification }}</div>
                    </div>
                    <input type="text" class="form-control" placeholder="Usuario" autocomplete="off" v-model="person_select.nick">
                    <button class="btn btn-outline-success" :disabled="boton_charge" @click="mTransfiereUsuario"><font-awesome-icon icon="arrows-alt-h" :bounce="boton_charge" /> Registrar</button>
                </div>
                <br>
                <div class="form-row">
                    <p class="text-danger">NOTA IMPORTANTE</p>
                    <p class="text-body"> Cuando realice la operacion de registro el personal quedara habilitado por 30 dias a partir de la fecha <b>pasada esa fecha quedara inhabilitado</b> para habilitarlo nuevamente dirijare a la segunda pestaña.</p>
                </div>
            </div>
        </div>
        <!-- end tab 1 -->
         <div class="tab-pane fade show " id="nav-list-user" role="tabpanel" aria-labelledby="nav-new-user-tab">
            <br><br>
            <h5>LISTADO DE USUARIO HABILITADOS EN LA UNIDAD</h5>
            <button class="btn btn-outline-success col-12 col-md-4 offset-md-4" @click="mListaUsuariosMios">Listar Personal Habilitados por mi Usuario</button>
            <div class="table-responsive" v-if="list_user.length > 0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th align="center">#</th>
                                <th align="center">Nombre completo</th>
                                <th align="center">Usuario</th>
                                <th align="center">Categoria</th>
                                <th align="center">Estado</th>
                                <th align="center">Habilitar/Inhabilitar</th>
                                <th align="center">Reset Contraseña</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(us, key) in list_user" :key="us.id">
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ key+1 }}</td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.complete }}</td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.nick }}</td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' ">{{ us.category }}</td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR'">
                                    <span class="alert alert-success" v-if="us.state === 'A'"><font-awesome-icon icon="arrow-circle-up" size="lg" /></span>
                                    <span class="alert alert-danger" v-else><font-awesome-icon icon="arrow-circle-down" size="lg" /></span></td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' " align="center">
                                    <button class="btn btn-success" v-if="us.state==='A'" @click="mChangeState(us.id, key)"><font-awesome-icon icon="toggle-on" size="lg" /></button>
                                    <button class="btn btn-danger" v-else @click="mChangeState(us.id, key)"><font-awesome-icon icon="toggle-off" size="lg" /></button>
                                </td>
                                <td v-if="us.category !=='SUPER ADMINISTRADOR' " align="center"><button class="btn btn-warning" @click="mResetPass(us)"><font-awesome-icon icon="sync-alt" size="lg" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            
            </div>
        
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    data(){
        return{
            persons:null,
            persons_list:[],
            searchPerson:'Busqueda de Personas',
            person_select:{
                id:0,
                complete:'',
                grade:'',
                identification:'',
                nick:'',
                first_name:'',
                last_name:''
            },
            boton_charge:false,
            list_user:[]
        }
    },
    methods:{
        async mChangeState(idp, idx){
            let nstate;
            if(this.list_user[idx].state==='A'){
                this.list_user[idx].state='I';
                nstate=false;
            }else{
                this.list_user[idx].state='A';
                nstate=true;
            }
            let vuser={
                id:idp,
                ns:nstate
            }
            try {
                let ns=await axios.post(`updateStatusUser?api_token=${Vue.auth.getToken()}`, qs.stringify(vuser));    
                if(ns.data.status){
                    toastr.success(`${ns.data.response}`, 'Exito')
                }else{
                    toastr.error(`${ns.data.response}`, 'Error')
                }
            } catch (error) {
                console.log(error)
            }
        },
        mResetPass(usr){
            let message = {
                title: 'Reiniciar Contraseña',
                body: `¿Desea Continuar con el reinicio de contraseña del usuario <b>${usr.nick}</b>?`
            };
            // validar que los datos esten completos
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });
            npr.then(async (msg)=>{
                if(msg){
                    
                    try {
                                    
                        this.mShowModal(this.modal_load_id);
                        let reset_pass=await axios.get(`updatePasswordUser/${usr.id}?api_token=${Vue.auth.getToken()}`);

                        setTimeout(()=>{                                
                            if(reset_pass.data.status){
                                toastr.success(reset_pass.data.response, 'Exito');
                            }else{
                                toastr.error(reset_pass.data.response, 'Error');
                            }                                    
                            this.mHideModal(this.modal_load_id);
                        },1000)

                    }catch(err){                
                        setTimeout(()=>{
                            toastr.error('Ha ocurrido un error en el reinicio de la contraseña', 'Error')
                            this.mHideModal(this.modal_load_id);
                        }, 3000)
                    }
                }else{
                    console.log('No se reinicio la contraseña');
                }
            });
        },
        mSelectPerson(data){            
            this.person_select.id=data.id;
            this.person_select.complete=data.complete;
            this.person_select.charge=data.complete;
            this.person_select.identification=data.identification;
            this.person_select.grade=data.grade;
            this.person_select.first_name=data.first_name;
            this.person_select.last_name=data.last_name;
            this.person_select.name=data.name;
            this.person_select.nick=this.mGeneraNick();
        },
        mClearSelectPerson(){
            this.person_select.id=0;
            this.person_select.complete='';
            this.person_select.charge='';
            this.person_select.identification='';
            this.person_select.grade='';
            this.person_select.first_name='';
            this.person_select.last_name='';
            this.person_select.name='';
            this.person_select.nick='';
        },
        mValidaTransferencia(){
          if(this.person_select.nick.trim()===''){
            toastr.warning(`Debe señalar un usuario para su registro`)
            return false;
          }
        //   aqui podemos señalar si va al servidor a consultar si el usuario esta vigente opcional
          return true;
        },
        async mTransfiereUsuario(){
            if(this.mValidaTransferencia()){
                // aqui enviamos al servidor a registrar el usuario
                let message = {
                    title: 'Habilitación de Usuario',
                    body: `¿Desea Registrar al nuevo Usuario <b>${this.cDtsUser.nick}</b> al Usuario <b>${this.person_select.nick}</b> perteneciente a la persona <b>${this.person_select.complete}</b>, para que proceda al registro solamente de personal y/o unidades de superficie?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.boton_charge = true;
                            let n_user_ordop=await axios.post(`registerTemporal?api_token=${Vue.auth.getToken()}`, qs.stringify(this.person_select));
                            setTimeout(()=>{                                
                                if(n_user_ordop.data.status){
                                    toastr.success(n_user_ordop.data.respuesta);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    this.boton_charge = false;
                                    // limpiamos los registros previamente obtenemos el id
                                    this.mClearSelectPerson();
                                    this.logout()
                                }else{
                                    toastr.warning(n_user_ordop.data.respuesta);
                                    this.boton_charge = false;
                                }
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
                this.btn_p_ordop = false;
                
            }
        },
        mGetRandomInt(max) {
            return Math.floor(Math.random() * max);
        },
        mGeneraNick(){
            let aux=`${this.person_select.name.charAt(0)}${this.person_select.first_name}_${this.mGetRandomInt(2025)}`;
            aux= aux.replace(/ /g, "").toLowerCase();
            return aux;
        },
        async mListaUsuariosMios(){
            // aqui llamamos para listar a los usuarios registrados por este usuario
            // this.list_user=[];
            try {
                let recupera_usuarios=await axios.get(`getRecuperamiusuarios?api_token=${Vue.auth.getToken()}`);
                // console.log(recupera_usuarios);
                this.list_user=recupera_usuarios.data;
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                console.log(res);
                this.persons_list=res.data;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/newUserUnidad.vue